import { Injectable } from '@angular/core';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';

@Injectable({
  providedIn: 'root'
})

export class CSVreportsService {

  private baseURL = environment.baseUrl;

  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

    getCSVReports(id): Observable<any> {
        return this.http.get(this.baseURL + '/rhAPI/jobEntry/getcsvreports/' + id);
    }

    getBaseURL(): string {  
      return this.baseURL;
    }

}
